import { Observable } from "@jetjs/streams";
export const on = (node, options) => {
    // validate options
    if (options.event === undefined) {
        throw new Error("Option [event] must be specified to execute the on Plugin");
    }
    // return a new observable
    return new Observable((subscriptionObserver) => {
        // producer - function called if the stream should be started (a subscriber is registered)
        const listener = (event) => {
            // pass event to the stream
            subscriptionObserver.next(event);
        };
        // start listening for events
        node.addEventListener(options.event, listener);
        return () => {
            // cancel observable (remove event listener from node)
            node.removeEventListener(options.event, listener);
        };
    });
};
//# sourceMappingURL=on.js.map